interface UserInitialsSource {
    firstName?: string | null;
    lastName?: string | null;
    initials?: string | null;
}

const firstLetter = (value?: string | null): string => {
    const [letter] = [...(value ?? '').trim()];
    return letter ? letter.toUpperCase() : '';
};

/**
 * The initials shown in the user's avatar: the first letters of the first and last name, so they follow the name the
 * user has now. Only when the user has neither name, the initials the user endpoint returns; when that is empty
 * as well, an empty string.
 */
export const getUserInitials = (user?: UserInitialsSource | null): string => {
    const fromName = `${firstLetter(user?.firstName)}${firstLetter(user?.lastName)}`;
    return fromName || user?.initials?.trim() || '';
};
